<div class="row g-3 add-on-features">
  <div class="col col-12">
    <h4 class="display-4">
      {{ 'add_on_features' | translate }}
    </h4>

    <hr class="m-0" />
  </div>

  <div class="col col-12">
    <div
      class="row g-3"
      [tds-data-loader]="{
        key: !shopping_cart ? 'asset-item' : 'device-plan-features',
        class: 'col w-100 py-4',
        size: 'lg'
      }"
    >
      <div *ngFor="let feature of add_on_features" class="col col-12">
        <div
          as-button
          class="card"
          [class.active-card]="
            includedFeature(feature) || addedFeature(feature) || currentFeature(feature)
          "
          [class.elevate]="
            !includedFeature(feature) && !addedFeature(feature) && !currentFeature(feature)
          "
          [attr.aria-label]="feature.name"
          (click)="manageFeatures(feature)"
        >
          <div class="card-body">
            <div class="row d-flex">
              <div class="col">
                <h5 class="line-clamp-2 text-break">
                  {{ getFeatureName(feature) }}
                </h5>

                <div *ngIf="includedFeature(feature)" class="fst-italic">
                  <span>*{{ 'included_feature_policy_hint' | translate }}</span>
                </div>

                <button
                  stop-click-propagation
                  *ngIf="feature.description"
                  class="btn btn-link neutral-btn text-capitalize fw-light text-decoration-underline focus-visible"
                  (click)="viewDetails(feature)"
                >
                  {{ 'view_details' | translate }}
                </button>
              </div>

              <div class="col col-auto text-end">
                <div class="d-flex gap-4">
                  <div class="d-flex align-items-center">
                    <ts-badge
                      *ngIf="currentFeature(feature)"
                      text="{{ 'current' | translate }}"
                      variant="primary"
                    />

                    <ts-badge
                      *ngIf="
                        (includedFeature(feature) || addedFeature(feature)) &&
                        !existingFeature(feature)
                      "
                      text="{{ 'added' | translate }}"
                      variant="success"
                    />

                    <ts-badge
                      *ngIf="removedFeature(feature)"
                      text="{{ 'removed' | translate }}"
                      variant="danger"
                    />
                  </div>

                  <div>
                    <h5 class="mb-0">
                      {{ feature.cost_to_currency ?? feature.cost?.cost_to_currency }}
                    </h5>
                    <small class="text-secondary">
                      {{ 'per_month' | translate }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="no_features" class="alert alert-danger col col-12 my-3" role="alert">
      <span>{{ 'features_no_results' | translate }}</span>
    </div>
  </div>
</div>
